import React, { useEffect, useState, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, withRouter } from "react-router-dom";

import { ResumePopupContext } from "../../Context/resumePopupContext";
import { suggestionListFront } from "../../Store/Actions/SuggestionActions";
import { jobsListFront } from "../../Store/Actions/JobActions";
import CreatableSelect from "react-select/creatable";
import Draggable from "react-draggable";
import { Scrollbars } from "react-custom-scrollbars-2";
import { sampleSuggestion } from "../../masterData";
import "./SuggestionVisual.scss";
import OutsideClickHandler from "react-outside-click-handler";

function SideTemplate(props) {
  const dispatch = useDispatch();
  const [selectedValue, setSelectedValue] = useState("");
  const [options, setOptions] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [job, setJob] = useState("");
  const { id } = useParams();

  const [rand, setRand] = useState("");
  const [suggestionArray, setSuggestionArray] = useState("");
  const path = window.location.pathname;
  const {
    preview,
    setPreview,
    sideBasic,
    setSideBasic,
    suggestionSection,
    setSuggestionSection,
    suggestionIndex,
    setSuggestionIndex,
    jobTitle,
  } = useContext(ResumePopupContext);
  const jobData = useSelector((state) => state.jobList.job);
  const suggestionData = useSelector(
    (state) => state.suggestionFront.suggestion
  );
  const handleChange = (e) => {
    var divElem = document.getElementById("suggestion-div-visual-input");
    var inputElements = divElem.querySelectorAll("input"),
      i;
    for (i = 0; i < inputElements.length; ++i) {
      inputElements[i].blur();
    }

    setJob(e.label);
    setSelectedValue(e);
    let local_jobtitle = JSON.parse(localStorage.getItem("user_settings"));
    if (local_jobtitle) {
      local_jobtitle.dropdownSelect = {
        job_title: e.label,
      };
    } else {
      local_jobtitle = {};
      local_jobtitle.dropdownSelect = {
        job_title: e.label,
      };
    }

    localStorage.setItem("user_settings", JSON.stringify(local_jobtitle));
  };

  const addText = (value) => {
    var listStart = "<ul><li>";
    var listEnd = "</li></ul>";
    var suggestionValue = listStart + value + listEnd;
    setSuggestionIndex(props.index);
    if (props.sectionId === "summary") {
      props.contentAdder(value, 0, props.sectionId);
    } else {
      props.contentAdder(suggestionValue, props.index, props.sectionId);
    }
  };

  const handleInputChange = (value) => {
    if (value != "") {
      dispatch(jobsListFront(value));
    } else {
      setOptions([]);
    }

    setRand(1);
    setInputValue(value);
  };

  const customStyles = {
    control: (base) => ({
      ...base,
      //   height: 50,
      //   minHeight: 50,
      left: "20px",
      border: "none",
      boxShadow: "none",
      backgroundColor: "transparent",
    }),
    input: (base, { data, isDisabled, isFocused, isSelected }) => ({
      ...base,
      borderBottom: isFocused ? "none" : "none",
    }),
    // valueContainer: (base) => ({
    //   ...base,
    //   height: 35,
    // }),
    // placeholder: (base) => ({
    //   ...base,
    //   top: 30,
    // }),
    // singleValue: (base) => ({
    //   ...base,
    //   top: 30,
    // }),
    option: (base, { data, isDisabled, isFocused, isSelected }) => ({
      ...base,
      height: 35,
      minHeight: 35,
      color: isFocused ? "white" : "black",
      backgroundColor: isFocused ? "#009b61" : "white",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      //    color:'#000000'
      display: "none",
    }),
    indicatorSeparator: (base) => ({
      ...base,
      display: "none",
    }),
  };

  useEffect(() => {
    if (!preview) {
      dispatch(jobsListFront());
    }
  }, []);

  useEffect(() => {
    if (job && job !== "") {
      let sample_id, resume_id;
      if (path.includes("create")) {
        sample_id = id;
      } else {
        resume_id = id;
      }

      dispatch(suggestionListFront(job, props.sectionId, sample_id, resume_id));
    }
  }, [job]);

  useEffect(() => {
    if (props && props.job && props.job != "") {
      setJob(props.job);
      setSelectedValue({ label: props.job, value: props.job });
    } else {
      let local_jobtitle = JSON.parse(localStorage.getItem("user_settings"));
      if (local_jobtitle) {
        if (local_jobtitle.editor) {
          setJob(local_jobtitle.editor.job_title);
          setSelectedValue({
            label: local_jobtitle.editor.job_title,
            value: local_jobtitle.editor.job_title,
          });
        } else if (local_jobtitle.accountSettings) {
          setJob(local_jobtitle.accountSettings.job_title);
          setSelectedValue({
            label: local_jobtitle.accountSettings.job_title,
            value: local_jobtitle.accountSettings.job_title,
          });
        } else if (local_jobtitle.dropdownSelect) {
          setJob(local_jobtitle.dropdownSelect.job_title);
          setSelectedValue({
            label: local_jobtitle.dropdownSelect.job_title,
            value: local_jobtitle.dropdownSelect.job_title,
          });
        } else if (local_jobtitle.dropdownSelectSample) {
          setJob(local_jobtitle.dropdownSelectSample.job_title);
          setSelectedValue({
            label: local_jobtitle.dropdownSelectSample.job_title,
            value: local_jobtitle.dropdownSelectSample.job_title,
          });
        }
      } else {
        dispatch(
          suggestionListFront(
            jobData && jobData[0] && jobData[0].job_title,
            props.sectionId
          )
        );
      }
    }
  }, [props.job]);

  useEffect(() => {
    let optionArray = [];
    jobData &&
      jobData.map((data) => {
        optionArray.push({ label: data.job_title, value: data.job_title });
      });
    setOptions(optionArray);
  }, [jobData]);

  useEffect(() => {
    setSuggestionArray(suggestionData && suggestionData.data);
  }, [suggestionData]);

  const handleClose = () => {
    props.hideSuggest();
  };
  const handleFocus = () => {
    setSelectedValue("");
    setOptions([]);
  };

  return (
    <OutsideClickHandler
      onOutsideClick={(e, value) => {
        const parentWithClass = e.target.closest(".suggestion-visual");
        if (props && props.showSuggest && parentWithClass == null) {
          handleClose();
        }
      }}
    >
      <div className="suggestion-visual bg-gray">
        <div className="suggestion-visual-inner-div">
          <span className="suggestion-search">
            <i class="fa fa-search" aria-hidden="true"></i>
          </span>
          <span className="suggestion-close" onClick={() => handleClose()}>
            <i class="fa fa-times" aria-hidden="true"></i>
          </span>
          <CreatableSelect
            maxMenuHeight={150}
            placeholder="Enter Jobtitle"
            value={selectedValue}
            // onChange={this.handleChange}
            onFocus={handleFocus}
            onInputChange={handleInputChange}
            onChange={handleChange}
            styles={customStyles}
            options={options}
            noOptionsMessage={() => null}
            id="suggestion-div-visual-input"
            formatCreateLabel={(userInput) => `Search for ${userInput}`}
            //   components={{ DropdownIndicator }}
          />
          <hr className="m-0 pb-3" />
          <Scrollbars style={{ height: "320px" }}>
            <div className="suggestion-div-visual">
              {suggestionArray && suggestionArray.length == 0 && (
                <>
                  <div
                    className=" align-items-center suggestion-each-item"
                    style={{ padding: "10px" }}
                  >
                    <div
                      style={{
                        fontSize: "13px",
                        marginLeft: "10px",
                        width: "90%",
                        color: "red",
                      }}
                    >
                      No matching content available for this job
                    </div>
                  </div>
                </>
              )}
              {
                suggestionArray &&
                  suggestionArray.length > 0 &&
                  suggestionArray.map((res, index) => {
                    let div = document.createElement("div");
                    div.className = "splitli";
                    div.innerHTML = res.description;

                    let list = div.getElementsByTagName("li");

                    let data = [];
                    if (props && props.sectionId == "experience") {
                      for (let i = 0; i < list.length; i++) {
                        data.push({
                          description: list[i].innerText
                            .replace(/(?:\\r\\n|\\r|\\n)/g, "<br>")
                            .replace(/\\/, "")
                            .replace(/<[^>]*>?/gm, ""),
                        });
                      }
                    } else {
                      data.push(res);
                    }

                    return (
                      data &&
                      data.length > 0 &&
                      data.map((suggest, suggestIndex) => (
                        <>
                          <div
                            className="d-flex align-items-center suggestion-each-item"
                            style={{ padding: "4px 10px" }}
                            onClick={() =>
                              addText(suggest && suggest.description)
                            }
                          >
                            <div>
                              <i
                                class="fa fa-arrow-left"
                                aria-hidden="true"
                                style={{
                                  background: "#fff",
                                  padding: "6px",
                                  borderRadius: "100%",
                                  border: "6px solid #ccc",
                                }}
                              ></i>
                            </div>
                            <div
                              style={{
                                fontSize: "13px",
                                marginLeft: "10px",
                                width: "90%",
                              }}
                              dangerouslySetInnerHTML={{
                                __html: suggest && suggest.description,
                              }}
                            ></div>
                          </div>

                          {/* <div
                      style={{
                        background: "#009b61",
                        width: "100%",
                        height: "0.5px",
                      }}
                    ></div> */}
                        </>
                      ))
                    );
                  })
                //   : sampleSuggestion &&
                //     sampleSuggestion.map((res, index) => (
                //       <>
                //         <div
                //           className="d-flex align-items-center suggestion-each-item"
                //           style={{ padding: "10px" }}
                //           onClick={() => addText(res && res.description)}
                //         >
                //           <div
                //             className="plus-button-suggest"
                //             style={{
                //               width: "40px",
                //               height: "40px",
                //               backgroundColor: "#edf0f1",
                //               borderRadius: "50%",
                //             }}
                //           >
                //             {/* <img
                // 		  style={{ width: "16px", height: "16px" }}
                // 		  src="/images/plusgreen.svg"
                // 		/> */}
                //             <i
                //               class="fa fa-arrow-left"
                //               aria-hidden="true"
                //               style={{ width: "16px", height: "16px" }}
                //             ></i>
                //           </div>
                //           <div
                //             style={{
                //               fontSize: "13px",
                //               marginLeft: "10px",
                //               width: "90%",
                //             }}
                //             dangerouslySetInnerHTML={{
                //               __html: res && res.description,
                //             }}
                //           ></div>
                //         </div>

                //         {/* <div
                // 	  style={{
                // 		background: "#009b61",
                // 		width: "100%",
                // 		height: "0.5px",
                // 	  }}
                // 	></div> */}
                //       </>
                //     ))
              }
            </div>
          </Scrollbars>
        </div>
      </div>
    </OutsideClickHandler>
  );
}

export default SideTemplate;
